import React from 'react';
import clsx from 'clsx';
import '@isyc-react/design/main';
export const ViewerControlsBox = props => {
  const {
    children,
    className
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('d-flex align-items-center h-100', className)
  }, children);
};